.spinner {
  display: inline-block;
  box-sizing: border-box;
  width: var(--spinner-size, 1.25rem);
  height: var(--spinner-size, 1.25rem);
  border: 2px solid var(--spinner-track, var(--border-light));
  border-top-color: var(--spinner-indicator, var(--brand-solid));
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Keep motion to signal progress, but slow it for reduced-motion users. */
@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 1.5s;
  }
}
